import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { STEP_COPY } from '../constants';

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmExitDialog({ open, onCancel, onConfirm }: Props): JSX.Element {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="self-service-smb-confirm-exit-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="self-service-smb-confirm-exit-title">
        {STEP_COPY.confirmExit.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{STEP_COPY.confirmExit.body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm}>{STEP_COPY.confirmExit.confirm}</Button>
        <Button onClick={onCancel} color="primary" variant="contained" autoFocus>
          {STEP_COPY.confirmExit.cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
